module.exports = __webpack_public_path__ + "img/SHINHANFINANCE.d93d7067.svg";